<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <material-card color="secondary" title="Indicações" text="">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-flex xs12 md12 class="text-lg-right">
            <div
              class="text-xs-rigth text-md-rigth text-lg-rigth"
              v-if="items.length > 0"
            >
              <v-btn
                color="primary"
                outline
                slot="start"
                @click="_export(items)"
              >
                <v-icon left>mdi-file-excel</v-icon>Exportar
              </v-btn>
            </div>
          </v-flex>
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            :loading="true"
            :search="search"
            no-data-text="Não há indicações cadastrados"
            rows-per-page-text="Linhas por página"
            :pagination.sync="pagination"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading text-xs-right font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.created_at | formatarDate }}</td>
              <!-- Indicador -->
              <td>{{ item.referral_indicator }}</td>
              <td class="text-xs-right">
                {{ item.referral_value_indicator | formatCurrency }}
              </td>
              <td>{{ item.competence_payment_indicator || "" }}</td>
              <!-- Indicado -->
              <td>{{ item.referral_indicated }}</td>
              <td class="text-xs-right">
                {{ item.referral_value_indicated | formatCurrency }}
              </td>
              <td>{{ item.competence_payment_indicated || "" }}</td>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning"
                >Sua busca para "{{ search }}" não retornou resultados.
              </v-alert>
            </template>
            <template v-slot:pageText="items"
              >Linhas {{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }}
            </template>
          </v-data-table>
          <template v-slot:loading>
            <v-progress-linear
              v-if="loading"
              height="2"
              color="cyan"
              indeterminate
            ></v-progress-linear>
          </template>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
// import { EventBus } from '../../utils/event-bus'
import XLSX from "xlsx";
import moment from "moment";

export default {
  props: ["referrals"],
  data: () => ({
    loading: false,
    dialog: false,
    search: "",
    items: [],
    total: 0,
    cols: [],
    pagination: {
      sortBy: "item.updated_at",
      rowsPerPage: 10,
    },
    data: [
      [
        "Indice",
        "Criado em",
        "Ultima Atualização",
        "Indicador Email",
        "Indicador Nome",
        "Beneficio",
        "Pago em",
        "Na Planta",
        "Indicador Email",
        "Indicador Nome",
        "Pago em",
        "Na Planta",
      ],
    ],
    headers: [
      {
        sortable: true,
        text: "Criado em",
        value: "created_at",
      },
      {
        sortable: true,
        text: "Indicador",
        value: "referral_indicator",
      },
      {
        sortable: true,
        text: "Beneficio",
        value: "referral_value_indicator",
      },
      {
        sortable: true,
        text: "Pago em",
        value: "competence_payment_indicator",
      },
      {
        sortable: true,
        text: "Indicado",
        value: "referral_indicated",
      },
      {
        sortable: true,
        text: "Beneficio",
        value: "referral_value_indicated",
      },
      {
        sortable: true,
        text: "Pago",
        value: "competence_payment_indicated",
      },
    ],
  }),
  mounted() {
    this.loading = true;
    this.items = this.referrals;
    this.loading = false;
    // EventBus.$on('LoadReferrals', referrals => {
    //     // console.log('LoadInvoices: ', invoices)
    //     this.items = referrals
    // });
  },
  methods: {
    _export(items) {
      /* convert state to workbook */
      items.forEach((item, index) => {
        item.id = index;
        this.data.push([
          index + 1,
          this.formatDate(item.created_at),
          this.formatDate(item.updated_at),
          // Dados do indicador
          item.referral_indicator || "",
          item.user_indicator.name || "",
          item.referral_value_indicator || 0,
          item.competence_payment_indicator || "",
          item.power_plant_payment_indicator || "",
          // Dados do Indicado
          item.referral_indicated || "",
          item.user_indicated.name || "",
          item.referral_value_indicated || 0,
          item.competence_payment_indicated || "",
          item.power_plant_payment_indicated || "",
        ]);
        // console.log('data: ', this.data)
      });
      const ws = XLSX.utils.aoa_to_sheet(this.data);
      const wb = XLSX.utils.book_new();

      const file = "referral_" + this.formatFileName(new Date());
      // XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      XLSX.utils.book_append_sheet(wb, ws, file);
      /* generate file and send to client */
      XLSX.writeFile(wb, file + ".xlsx");
    },
    formatDate(value) {
      if (!value) return "";
      let timestamp = value; // firebase data
      let myDate = new Date();
      if (timestamp._seconds) {
        myDate = new Date(timestamp._seconds * 1000); // date object
      } else {
        myDate = new Date(timestamp); // date object
      }

      return moment(myDate.toISOString().substr(0, 10)).format("DD/MM/YYYY");
    },
    formatFileName(value) {
      if (!value) return "";
      const year = value.getYear();
      const month = value.getMonth() + 1;
      const day = value.getDay();
      const hour = value.getHours();
      const minute = value.getMinutes();
      return day + "" + month + "" + year + "" + hour + "" + minute;
    },
    sumFee(value) {
      if (!value || value.length === 0) return 0;
      var sum = value.reduce(function (sum, elem) {
        return sum + elem.fee;
      }, 0);
      return sum / 100;
    },
  },
  filters: {
    formatCurrency(value) {
      let val = (value * 1).toFixed(2).replace(".", ",");
      return "R$ " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatPercent(value) {
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val;
    },
    formatStatus: function (value) {
      if (!value) return "";

      if (value === "paga" || value === "succeeded" || value === "paid") {
        return "done_outline";
      } else if (
        value === "aberta" ||
        value === "pending" ||
        value === "waiting_payment" ||
        value === "opened"
      ) {
        return "schedule";
      } else if (value === "free") {
        return "free_breakfast";
      } else {
        return "error";
      }
    },
    formatPaymentType: function (value) {
      if (!value) return "";

      if (value === "credit" || value === "credit_card") return "credit_card";
      else return "mdi-barcode";
    },
    formatName: function (value) {
      if (!value) return "";
      if (value.length > 25) {
        return value.substr(0, 25) + "...";
      } else {
        return value;
      }
    },
    sumFee(value) {
      if (!value || value.length === 0) return 0;
      var sum = value.reduce(function (sum, elem) {
        return sum + elem.fee;
      }, 0);
      return sum / 100;
    },
  },
};
</script>
